import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as FPT from '../../utility/fpt';
import { Icon } from '@paypalcorp/pp-react-icons';
import { grey700 } from '@paypalcorp/pp-react-colors';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';
import { EVENT_NAME, SCREEN_NAME } from '../../utility/constants';

const STYLES = {
  error: {
    color: grey700,
    fontSize: '13px',
  },
  criticalIcon: {
    color: '#D20000',
    position: 'relative',
    fontSize: 'unset',
    marginRight: '5px',
  },
};

/**
 * Component for displaying amount validation error message
 */
class AmountValidationError extends Component {
  componentDidMount() {
    const { errorSourceField, errorString, errorCode } = this.props;
    const errorObj = {
      message: errorString,
      fieldId: errorSourceField,
      code: errorCode || 'DONATION_AMOUNT_VALIDATION_ERROR',
    };
    FPT.trackDonationAmount();
    if (isExternalFlow()) {
      errorObj.event_name =
        EVENT_NAME.DW_GIVING_FAILED_CUSTOMER_INTERACTION_OCCURRED;
      errorObj.screen = window.fpti?.page?.includes('landing')
        ? SCREEN_NAME.DW_GIVING_DONATE_SETUP_SCREEN
        : SCREEN_NAME.DW_GIVING_DONATE_GUEST_FORM_SCREEN;
      errorObj.error_desc = errorString;
      errorObj.error_code = errorCode;
    }
    FPT.trackErrorWithData(errorObj);
  }
  render() {
    const { errorString } = this.props;

    if (!errorString) {
      return null;
    }

    return (
      <span>
        <Icon
          name="critical-alt"
          size="xs"
          style={{ ...STYLES.criticalIcon }}
        />
        <span
          role="alert"
          style={STYLES.error}
          data-testid="amount-validation-error"
        >
          {errorString}
        </span>
      </span>
    );
  }
}

AmountValidationError.propTypes = {
  errorString: PropTypes.string,
  errorSourceField: PropTypes.string,
  errorCode: PropTypes.string,
  donationAmount: PropTypes.string,
};

export default AmountValidationError;
